var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93005 5.34773C10.8324 3.71742 13.1792 3.71742 14.0815 5.34773C14.1058 5.39165 14.1256 5.43728 14.141 5.48399L20.8123 17.5484C20.8169 17.5568 20.8215 17.5654 20.8258 17.574C21.3649 18.6388 20.5847 19.875 19.4166 19.875H4.5791C3.3965 19.875 2.64803 18.6201 3.16777 17.5782C3.17277 17.5681 3.17799 17.5582 3.18342 17.5484L9.93005 5.34773ZM11.9418 15.8107C11.3574 15.8107 10.8836 16.2844 10.8836 16.8688C10.8836 17.4532 11.3574 17.927 11.9418 17.927C12.5262 17.927 13 17.4532 13 16.8688C13 16.2844 12.5262 15.8107 11.9418 15.8107ZM12.7318 8.5928C12.7318 8.15497 12.3777 7.80005 11.9409 7.80005C11.5041 7.80005 11.15 8.15497 11.15 8.5928V14.142C11.15 14.5799 11.5041 14.9348 11.9409 14.9348C12.3777 14.9348 12.7318 14.5799 12.7318 14.142V8.5928Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidWarning);
export default __webpack_public_path__ + "static/media/solid-warning.13eb4d3e68e2fd901169af87e616f343.svg";
export { ForwardRef as ReactComponent };